'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2016/8/30.
                    */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AttentionArtworkComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(AttentionArtworkComponent, _Component);

  function AttentionArtworkComponent() {
    (0, _classCallCheck3.default)(this, AttentionArtworkComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(AttentionArtworkComponent).call(this));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(AttentionArtworkComponent, [{
    key: 'render',
    value: function render() {
      var styles = require('./ArtSalonComponent.scss');
      var _props = this.props;
      var index = _props.index;
      var artSalon = _props.artSalon;

      var path = '/artSalon/' + artSalon.id;
      var rightClassName = styles.component;
      if ((index + 1) % 3 === 0) {
        rightClassName = rightClassName + ' ' + styles.mr0;
      }
      return _react2.default.createElement(
        'li',
        { className: rightClassName },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: path, target: '_blank' },
          _react2.default.createElement(
            'div',
            { className: styles.img },
            _react2.default.createElement('img', { className: styles.big, src: artSalon.img }),
            _react2.default.createElement('img', { className: styles.sat, src: artSalon.QRcode })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.txt },
            _react2.default.createElement(
              'h3',
              null,
              artSalon.name
            ),
            _react2.default.createElement(
              'span',
              { className: styles.span },
              artSalon.salonDescribe
            )
          )
        )
      );
    }
  }]);
  return AttentionArtworkComponent;
}(_react.Component), _class.propTypes = {
  index: _react.PropTypes.number.isRequired,
  artSalon: _react.PropTypes.array.isRequired
}, _temp);
exports.default = AttentionArtworkComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ArtSalonComponent/ArtSalonComponent.js
 ** module id = 1309
 ** module chunks = 0
 **/